import React from "react";
import { Container } from "react-bootstrap";
import { FaCheck, FaTimes, FaYoutube, FaGlobe, FaClock, FaMoneyBillWave, FaChartBar, FaFingerprint, FaFileAlt, FaTag, FaCalendarAlt, FaUsers, FaCheckCircle, FaMoneyCheckAlt, FaMusic } from "react-icons/fa";
import { motion } from "framer-motion";
import "./Price.css";

const PriceTab = () => {
  const features = [
    { name: "Revenue shares", icon: <FaMoneyBillWave />, free: "80%", pro: "80%", label: "80%" },
    { name: "YouTube Content ID", icon: <FaYoutube />, free: "Limited time only", pro: true, label: true },
    { name: "Unlimited releases to 150+ digital stores & social media platforms", icon: <FaGlobe />, free: true, pro: true, label: true },
    { name: "Release approval time", icon: <FaClock />, free: "24-48 hr", pro: "24-48 hr", label: "24-48 hr" },
    { name: "Support response time", icon: <FaClock />, free: "48 hours", pro: "24 hours", label: "Same day" },
    { name: "Artists included", icon: <FaUsers />, free: "1", pro: "3", label: "Unlimited" },
    { name: "Spotify artist verified checkmark", icon: <FaCheckCircle />, free: true, pro: true, label: true },
    { name: "Royalty splits", icon: <FaMoneyCheckAlt />, free: true, pro: true, label: true },
    { name: "Use your own ISRC", icon: <FaFingerprint />, free: true, pro: true, label: true },
    { name: "Lyrics management with Musixmatch", icon: <FaMusic />, free: true, pro: true, label: true },
    { name: "Basic trends & earnings reports", icon: <FaChartBar />, free: true, pro: true, label: true },
    { name: "Advanced reporting", icon: <FaFileAlt />, free: false, pro: true, label: true },
    { name: "Custom label name", icon: <FaTag />, free: false, pro: false, label: true },
    { name: "Custom release date", icon: <FaCalendarAlt />, free: false, pro: true, label: true },
  ];

  const renderCell = (value) => {
    if (value === true) return <FaCheck className="check-icon" />;
    if (value === false) return <FaTimes className="cross-icon" />;
    if (value === "") return "";
    return value;
  };

  return (
    <div className="pricing-table-section">
      <Container>
        <motion.div 
          className="pricing-table-container"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <table className="pricing-table">
            <thead>
              <tr>
                <th>
                  <h2 className="text-gradient" style={{ marginBottom: 0 }}>Plans</h2>
                </th>
                <th>
                  Pay Per Release
                  <span className="price">₹299</span>
                </th>
                <th>
                  Pro Artists
                  <span className="price">₹1,499</span>
                </th>
                <th>
                  Record Labels
                  <span className="price">₹2,999</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {features.map((feature, index) => (
                <tr key={index} className="feature-row">
                  <td>
                    <div className="feature-label">
                      <div className="feature-icon-wrapper">
                        {feature.icon}
                      </div>
                      {feature.name}
                    </div>
                  </td>
                  <td>{renderCell(feature.free)}</td>
                  <td>{renderCell(feature.pro)}</td>
                  <td>{renderCell(feature.label)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </motion.div>
      </Container>
    </div>
  );
};

export default PriceTab;
